import { itemHistoricoRegularizacaoStyles } from './ItemHistoricoRegularizacao.style'

export function itemHistoricoRegularizacaoIO() {
  return {
    styles: itemHistoricoRegularizacaoStyles
  }
}

export type ItemHistoricoRegularizacaoIO = ReturnType<typeof itemHistoricoRegularizacaoIO>
